// src/components/Footer.js
import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
// import 'font-awesome/css/font-awesome.min.css';
import '../styles/Footer.css';


const Footer = () => {
  useEffect(() => {
    document.getElementById('footerYear').textContent = new Date().getFullYear();
  }, []);

  return (
    <footer className="footer-main">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-company-info">
              <h2 className="footer-company-name">K2 Peak Technologies</h2>
              <p className="footer-company-desc">
                Reproduction of material from any K2 Peak Technologies pages without permission is strictly prohibited.
              </p>
            </div>
          </div>

          <div className="footer-section">
            <h3 className="footer-section-title">Quick Links</h3>
            <ul className="footer-links-list">
              <li className="footer-links-item"><a href="#" className="footer-link">Contact</a></li>
              <li className="footer-links-item"><a href="#" className="footer-link">Support</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-section-title">Contact Info</h3>
            <div className="footer-contact-item">
              <i className="fas fa-map-marker-alt footer-contact-icon"></i>
              <span>K2 Peak Technologies Near City Park , Skardu</span>
            </div>
            <div className="footer-contact-item">
              <i className="fas fa-phone footer-contact-icon"></i>
              <span>+92 3498016392</span>
            </div>
            <div className="footer-contact-item">
              <i className="fas fa-envelope footer-contact-icon"></i>
              <span>k2peaktechnologies.com</span>
            </div>
            <div className="footer-contact-item">
              <i className="fas fa-clock footer-contact-icon"></i>
              <span>Mon - Fri: 9:00 AM - 5:00 PM</span>
            </div>
          </div>
        </div>

        {/* Social Section */}
        <div className="footer-social-section">
          <h3 className="footer-social-title">Follow Us</h3>
          <div className="footer-social-links">
            <a href="#" className="footer-social-link"><i className="fab fa-facebook-f"></i></a>
            <a href="#" className="footer-social-link"><i className="fab fa-twitter"></i></a>
            <a href="#" className="footer-social-link"><i className="fab fa-instagram"></i></a>
            <a href="#" className="footer-social-link"><i className="fab fa-linkedin-in"></i></a>
            <a href="#" className="footer-social-link"><i className="fab fa-youtube"></i></a>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-privacy-links">
            <a href="#" className="footer-privacy-link">Privacy Policy</a>
            <a href="#" className="footer-privacy-link">Terms of Service</a>
            <a href="#" className="footer-privacy-link">Cookie Policy</a>
            <a href="#" className="footer-privacy-link">Disclaimer</a>
            <a href="#" className="footer-privacy-link">Sitemap</a>
          </div>
          <div className="footer-copyright">
            © <span className="footer-copyright-year" id="footerYear">
              2025
            </span>{' '}
            All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
